import { SimpleImage } from '$partials/media/image-simple';
import React from 'react';
import { formatLinkBlockToUrl } from '$utilities/data';
import Button from '$partials/ui/button';
import IconArrow from '$partials/icons/icon-arrow';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ListAndImage}
 */

const ListAndImage = ({
    image,
    heading,
    body,
    listItems
}) => {
    return (
        <div className='module-list-and-image theme-light bg-main-background relative md:py-48 sm:py-40 py-24'>
            <div className='layout-container layout-site-outer-padding'>
                {/* Title */}
                {heading && (
                    <h2 className='type-style-2 text-main-text-primary w-full mb-24'>
                        {heading}
                    </h2>
                )}

                <div className='col-wrapper flex md:flex-row sm:flex-col-reverse flex-col gap-y-24'>
                    <div className='hidden md:block md:w-7/12 col-padding'>
                        <SimpleImage
                            {...image.image}
                            className='w-full h-full object-cover aspect-video'/>
                    </div>
                    <div className='md:w-5/12 col-padding flex flex-col gap-y-24 sm:gap-y-16 md:gap-y-48'>
                        {body &&
                            <div
                                className='hidden md:block type-style-body-r text-main-text-primary mt-4'>
                                {body}
                            </div>
                        }
                        {listItems && listItems.length > 0 &&
                            <ul>
                                {listItems.map((item, index) => (
                                    <li
                                        className='border-t border-main-border py-12 sm:py-16 type-style-body-r'
                                        key={index}>
                                        <Button
                                            as='a'
                                            className='flex items-center justify-between hover:text-main-brand-text'
                                            href={formatLinkBlockToUrl(item.link)}>
                                            {item?.label}
                                            <IconArrow className='inline-block h-[10px]'/>
                                        </Button>
                                    </li>
                                ))}
                            </ul>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ListAndImage;
